export default __webpack_public_path__ + "static/figma-version-515267ae00ebcf0d6b3d38300381d341.gif";